import React, { useState, useCallback, useMemo, useEffect } from "react";
import { useFormikContext } from "formik";
import { Snackbar } from "@mui/material";
import MuiAlert from "@mui/material/Alert";
import EnhancedTableToolbar from "./EnhancedTableToolbar";
import GarmentComponent from "./GarmentComponent";

const Alert = React.forwardRef(function Alert(props, ref) {
  return <MuiAlert elevation={6} ref={ref} variant="filled" {...props} />;
});

const MuiSnackbar = React.forwardRef((props, ref) => {
  return <Snackbar ref={ref} {...props} />;
});
export const computeTotalParts = (list) =>
  (list || []).reduce((sum, g) => {
    const garmentCount = (g?.garment || []).filter(
      (p) => p && typeof p.garment === "string" && p.garment.trim().length > 0
    ).length;
    const fibreCount = (g?.fibres || []).filter(
      (f) => f && typeof f.fibre === "string" && f.fibre.trim().length > 0
    ).length;
    return sum + garmentCount + fibreCount;
  }, 0);
export function Fibre(props) {
  const { name, options, validation, headerList, showAlias, ...rest } = props;
  if (headerList && !headerList.find((x) => x.label == "" && x.value == "")) {
    headerList.splice(0, 0, {
      label: "",
      value: "",
    });
  }
  if (options && !options.find((x) => x.label == "" && x.value == "")) {
    options.splice(0, 0, {
      label: "",
      value: "",
    });
  }

  let { values, errors, touched } = useFormikContext();
  let data = values[name];

  const totalParts = useMemo(() => computeTotalParts(values[name]), [values[name]]);

  const getTotalParts = useCallback(() => totalParts, [totalParts]);


  const [open, setOpen] = useState({
    operBar: false,
    message: "",
    isValidPercentage: false,
  });

  const handleClose = (event, reason) => {
    if (reason === "clickaway") {
      return;
    }
    setOpen({
      operBar: false,
      message: "",
      isValidPercentage: false,
    });
  };

  return (
    <>
      <div className="tableformik">
        <EnhancedTableToolbar {...props} />
        <div className="fibre-box">
          <MuiSnackbar
            open={open.operBar}
            autoHideDuration={3000}
            onClose={handleClose}
            anchorOrigin={{ vertical: "top", horizontal: "center" }}
          >
            {open?.message?.length > 0 ? (
              <Alert
                onClose={handleClose}
                severity={open.isValidPercentage ? "success" : "error"}
                sx={{ width: "100%" }}
              >
                {open.message}
              </Alert>
            ) : null}
          </MuiSnackbar>

          <div className="table-container">
            <div className="table-head">
              <div className="fiber-flex-container">
                <div className="flex-fiber-item-left">
                  <label>Garment Component</label>
                </div>
                <div className="flex-fiber-item-left">
                  <label>Fibre</label>
                </div>
              </div>
            </div>
            <div className="table-body">
              {data?.map((garment, index) => (
                <div className="" key={index}>
                  <GarmentComponent
                    name={name}
                    key={index}
                    garmentIndex={index}
                    garment={garment}
                    setOpen={setOpen}
                    headerList={headerList}
                    options={options}
                    showAlias={showAlias}
                    mandatoryGarmentPart={validation.mandatoryGarmentPart}
                    componentMinMax={validation.componentMinMax}
                    getTotalParts={getTotalParts}
                  />
                </div>
              ))}
            </div>
          </div>

          {errors[name] && touched[name]?.[0]?.garment && (
            <span className="is-invalid">{errors[name]}</span>
          )}
        </div>
      </div>
    </>
  );
}
